import { Box } from '@mui/material';
import React, { FC } from 'react';

type InvoiceItemTypeProps = {
    invoiceType: string | null;
    deliveryMethod: string | null;
};

const InvoiceItemType: FC<InvoiceItemTypeProps> = ({ invoiceType, deliveryMethod }: InvoiceItemTypeProps) => {
    return (
        <Box>
            <Box>{invoiceType}</Box>
            <Box>{deliveryMethod}</Box>
        </Box>
    );
};

export default InvoiceItemType;
